(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'pointerenter',
    (e) => {
      const gallery = e.target.closest('.card-gallery');
      if (!gallery) return;
      const video = gallery.querySelector('.card-video');
      if (video) video.play();
    },
    true
  );

  document.addEventListener(
    'pointerleave',
    (e) => {
      const gallery = e.target.closest('.card-gallery');
      if (!gallery) return;
      const video = gallery.querySelector('.card-video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
